// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class WarningForChangeFromLastPriceGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.WARNING_FOR_CHANGE_FROM_LAST_PRICE_GROUP, null, pfixFieldSet);
    }
    getPriceLowLimit() {
        return this.GetValue(FieldsFactory.FIELD_PRICE_LOW_LIMIT) || 0;
    }
    getLastChange() {
        return this.GetValue(FieldsFactory.FIELD_LAST_CHANGE);
    }
}
